import { Component, inject, Input } from "@angular/core";
import { Constants } from "@core/constants";
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonTitle,
  IonToolbar,
  ModalController,
} from "@ionic/angular/standalone";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "pa-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.scss"],
  imports: [TranslatePipe, IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonFooter],
})
export class ConfirmModalComponent {
  @Input() title!: string;
  @Input() text!: string;
  @Input() info?: string;
  @Input() textOK = "label.ok";
  @Input() textCancel = "label.cancel";
  private readonly modalCtrl = inject(ModalController);

  cancel(): void {
    this.modalCtrl.dismiss(null, Constants.BUTTON_ACTION_CANCEL);
  }

  confirm(): void {
    this.modalCtrl.dismiss(null, Constants.BUTTON_ACTION_OK);
  }
}
